import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router';
import { useMutation } from '@apollo/client/react';
import styles from 'components/Header.module.css';
import Logo from 'components/Logo';
import { LogoutDocument } from 'graphql/mutations.generated';

const Header: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const [logout] = useMutation(LogoutDocument);

    const handleLogout = async () => {
        try {
            await logout();
            window.location.href = '/';
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <Link to="/" className={styles.siteName}>
                  <Logo /> Kongrego
        </Link>
        <nav className={styles.nav}>
                  <Link to="/browse-events" className={styles.navLink}>
                      Browse
                  </Link>
          <Link to="/account-settings" className={styles.navLink}>
            Settings
          </Link>
                  <button onClick={handleLogout} className={styles.navLink}>
                      Logout
                  </button>
        </nav>
              <div className={styles.mobileMenu} ref={menuRef}>
                  <div
                      className={styles.menuIcon}
                      onClick={() => setIsMenuOpen(!isMenuOpen)}
                  >
                      <span></span>
                      <span></span>
                      <span></span>
                  </div>
                  {isMenuOpen && (
                      <div className={styles.dropdownMenu}>
                          <Link
                              to="/browse-events"
                              className={styles.dropdownLink}
                              onClick={() => setIsMenuOpen(false)}
                          >
                              Browse
                          </Link>
                          <Link
                              to="/account-settings"
                              className={styles.dropdownLink}
                              onClick={() => setIsMenuOpen(false)}
                          >
                              Settings
                          </Link>
                          <button
                              onClick={() => {
                                  setIsMenuOpen(false);
                                  handleLogout();
                              }}
                              className={styles.dropdownLink}
                          >
                              Logout
                          </button>
                      </div>
                  )}
              </div>
      </div>
    </header>
  );
};

export default Header;

